import type { ClientResource } from '@majuscule/contracts';
import { formatEur } from '../lib/format';

/** Display helpers shared by the client list and the client detail screens. */

/** A cap, or « Aucun » when the cap does not apply. */
export function capLabel(value: string | null): string {
  return value === null ? 'Aucun' : formatEur(value);
}

/** Percent of a cap consumed, display-only, null when the cap does not apply. */
export function percentUsed(spent: string, cap: string | null): number | null {
  if (cap === null) {
    return null;
  }
  const capValue = Number(cap);
  const spentValue = Number(spent);
  if (!Number.isFinite(capValue) || capValue <= 0 || !Number.isFinite(spentValue)) {
    return null;
  }
  return (spentValue / capValue) * 100;
}

/** Consumption level against a cap, same thresholds as the cap gauges: 80 % and 100 %. */
export type CapLevel = 'ok' | 'warn' | 'over';

export function capLevel(percent: number): CapLevel {
  if (percent >= 100) {
    return 'over';
  }
  if (percent >= 80) {
    return 'warn';
  }
  return 'ok';
}

const DATE_TIME_FORMAT = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  dateStyle: 'short',
  timeStyle: 'short',
});

/** « 05/11/2026 18:19 » in the Europe/Paris business zone; the raw value if unparsable. */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : DATE_TIME_FORMAT.format(date);
}

/** True when the invoice cannot be issued: billing address or SIREN missing. */
export function billingInfoIncomplete(client: ClientResource): boolean {
  return client.billingAddress === null || client.siren === null;
}
